module.exports = __webpack_public_path__ + "img/play.2a53518d.svg";